import { CDError } from 'utils/error';
import { Auth } from 'aws-amplify';

export type LogoutVariables = {
  username: string;
};

const logoutRequest = async () => {
  try {
    return await Auth.signOut();
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export default logoutRequest;
